<div class="main app-background">
  <div class="content">
    <header class="content__header">
      <div class="flex flex-col sm:flex-row sm:justify-between mb-4 sm:mb-0">
        <h1 class="accent flex items-center gap-2 mat-headline-4">
          <mat-icon>menu_book</mat-icon>
          <span i18n>Unit Library</span>
        </h1>
        @if (showMyUnits) {
          <a
            mat-flat-button
            color="primary"
            class="self-start"
            href="{{ configService.getAuthoringToolLink() }}"
            i18n
            >Authoring Tool</a
          >
        }
      </div>
      <p class="pb-4" i18n>
        Explore our curriculum library to find units and resources to use with your classes!
      </p>
    </header>
    <section class="library notice-bg-bg rounded-md">
      <div class="flex flex-col md:flex-row">
        <div class="dark-theme content-block primary-bg p-4 md:w-1/3 lg:w-1/4">
          <app-library-filters [isSplitScreen]="true" />
        </div>
        <div class="md:w-2/3 lg:w-3/4">
          @if (showMyUnits) {
            <mat-tab-group dynamicHeight>
              <mat-tab [label]="getPublicTabLabel()">
                <public-library />
              </mat-tab>
              <mat-tab [label]="getMyUnitsTabLabel()">
                <app-personal-library />
              </mat-tab>
            </mat-tab-group>
          } @else {
            <public-library />
          }
        </div>
      </div>
    </section>
  </div>
</div>
